<template>
    <div>
        <h2 class="page-header">チーム情報の設定</h2>
        <p class="sentence">
            チーム名とチームを識別するためのチームキーを決定します。このキーがチームの URL の一部になります。
        </p>
        <div class="form-group">
            <label class="control-label" for="team-name">チーム名</label>
            <input type="text" class="form-control" id="team-name" size="25" maxlength="40" v-model="newName"/>
        </div>
        <div class="form-group">
            <h4 class="info-message">
                <template v-if="this.disabledTeamKeyField">
                    <span class="success" v-if="this.disabledTeamKeyField">チームキーは変更できません。</span>
                </template>
                <template v-else>
                    <span class="failer" v-if="(this.newTeamKey) && (this.newTeamKey != this.orgTeamKey) && this.teamKeyExited">このキーはすでに他のチームに使われています。</span>
                    <span class="success" v-if="(this.newTeamKey) && (this.newTeamKey != this.orgTeamKey) && ! this.teamKeyExited">このキーは利用できます。</span>
                </template>
            </h4>
            <label class="control-label" for="team-key">チームキー</label>
            <template v-if="this.disabledTeamKeyField">
                <input type="text" class="form-control" id="team-key" size="25" maxlength="40" v-model="newTeamKey" disabled="true" v-on:keyup="checkTeamKey($event.target.value)"/>
            </template>
            <input v-else type="text" class="form-control" id="team-key" size="25" maxlength="40" v-model="newTeamKey" v-on:keyup="checkTeamKey($event.target.value)"/>
            <div>
                <dd>チームの URL</dd>
                <dt>https://www.bitscheduler.com/home/{{ this.newTeamKey }}</dt>
            </div>
        </div>
        <div class="button-panel">
            <button id="register" class="btn btn-raised btn-primary commit" v-if="(this.updateMode)" @click="saveTeamData()">update</button>
            <button id="register" class="btn btn-raised btn-primary commit" v-if="(! this.updateMode)" v-bind:disabled="(! this.commitButtonEnabled)" @click="saveTeamData()">register</button>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Team from '../models/Team.js'

    export default {
        data: function() {
            return {
                updateMode: false,
                commitButtonEnabled: false,
                teamKeyExited: false,
                newName: null,
                newTeamKey: null,
                disabledTeamKeyField: false
            }
        },
        props: {
            orgName: String,
            orgTeamKey: String
        },
        methods: {
            checkTeamKey: function(inputKey) {
                let that = this
                console.debug(`inputKey: ${inputKey}`)

                if (inputKey) {
                    // 更新前データあり
                    if (that.orgTeamKey) {
                        if (that.orgTeamKey == inputKey) {
                            that.commitButtonEnabled = false
                        }
                        else {
                            Team.findByKey(inputKey).then(function(foundTeam) {
                                that.teamKeyExited = (foundTeam && Vue.prototype.$ownerId != foundTeam.ownerId) ? true : false
                                that.commitButtonEnabled = (foundTeam && Vue.prototype.$ownerId != foundTeam.ownerId) ? false : true
                            })
                        }
                    }
                    // 新規登録
                    else {
                        Team.findByKey(inputKey).then(function(foundTeam) {
                            that.teamKeyExited = (foundTeam) ? true : false
                            that.commitButtonEnabled = (foundTeam) ? false : true
                        })
                    }
                }
                else {
                    that.commitButtonEnabled = false
                }
            },

            saveTeamData: function() {
                let that = this
                that.$emit('save-team-data', that.$el.querySelector('#team-name').value, that.$el.querySelector('#team-key').value)
            },

            /**
             * @param boolean disabledTeamKeyField チームキー入力を無効にする場合 true
             */
            setDefaultData: function(name, teamKey, disabledTeamKeyField = false, updateMode = false) {
                this.updateMode = updateMode,
                this.newName = name,
                this.newTeamKey = teamKey,
                this.disabledTeamKeyField = disabledTeamKeyField
            }
        },
    }
</script>
<style>
</style>
